module.exports = __webpack_public_path__ + "ua.svg?bd82dfe13a2fe8f5c9223bc0410989b1";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ua.svg
// module id = 1405
// module chunks = 27